import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useGetAllCattleTypesService = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const allCattleTypesService = useQuery({
    queryKey: [...CACHE_KEYS.CATTLE_TYPES, page, debouncedQuery, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.CATTLE_TYPES,
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allCattleTypesService },
    states: { searchQuery, setSearchQuery },
  };
};

export const useGetSingleCattleTypesService = ({
  cattleType_id,
}: {
  cattleType_id: number;
}) => {
  const singleCattleTypeService = useQuery({
    queryKey: [CACHE_KEYS.SINGLE_CATTLE_TYPES, cattleType_id],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: `${URLS.CATTLE_TYPES}/${cattleType_id}`,
      }),
    enabled: cattleType_id ? true : false,
  });
  return { service: { singleCattleTypeService } };
};
